import React, { Component, Fragment } from 'react'
import { getLegalPage } from 'api/content'
import { scrollToHash } from 'lib/window/scrollUtils'
import { Location } from 'history'
import HeadData from 'components/Common/HeadData'
import Heading from 'components/Luxkit/Typography/Heading'
import MarkdownRender from 'components/Luxkit/MarkdownRender'
import ErrorPage from 'components/Pages/ErrorPage'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import config from 'constants/config'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import StaticContentPageContainer from 'components/Common/StaticContentPageContainer'

interface Props {
  slug: string;
  location: Location<any>
}

interface State {
  title: string;
  content: Array<any>;
  error: any;
  backgroundColour: string | undefined;
}

class LegalPages extends Component<React.PropsWithChildren<Props>, State> {
  state: State = {
    title: '',
    content: [],
    error: undefined,
    backgroundColour: 'grey',
  }

  componentDidMount() {
    this.fetchContent()
  }

  fetchContent = () => {
    const { slug, location } = this.props
    // We assume that luxuryescapes content has NO brand prefix in Contentful
    // Other brands expect brand prefix in the contentful slug
    getLegalPage(config.BRAND !== 'luxuryescapes' ? `${config.BRAND}-${slug}` : slug)
      .then(page => {
        if (page) {
          return this.setState({
            title: page.title,
            content: page.pageContent,
            backgroundColour: page.backgroundColour,
          }, () => scrollToHash(location.hash, true))
        }
      })
      .catch(error => this.setState({ error }))
  }

  render() {
    const { title, content, error } = this.state
    const loading = content.length === 0 && !error
    const errorStatus = error ? error.status : ''

    return (<>
      <HeadData title={title} />
      <StaticContentPageContainer>
        <VerticalSpacer gap={24}>
          <Heading variant="heading2" as="h1">{title}</Heading>
          {loading && <LoadingIndicator/>}
          {errorStatus && <ErrorPage error={errorStatus} />}
          {!loading && content.map((term) => (
            <Fragment key={term.slug}>
              <Heading id={term.slug} variant="heading3" format="uppercase" as="h2">{term.title}</Heading>
              <MarkdownRender content={term.description} />
            </Fragment>
          ))}
        </VerticalSpacer>
      </StaticContentPageContainer>
    </>)
  }
}

export default LegalPages
